export default __webpack_public_path__ + "static/media/close-button.631c257e.svg";